module.exports = "/interactives/anyang/life-in-the-city/_next/static/images/map-b8c034e47132a0e22beba9d258be95c5.jpg";